export default {
  GET_INVOICES: '@INVOICE/GET_INVOICES',
  GET_INVOICES_SUCCESS: '@INVOICE/GET_INVOICES_SUCCESS',
  GET_INVOICES_FAILURE: '@INVOICE/GET_INVOICES_FAILURE',
  CLEAR_INVOICES: '@INVOICE/CLEAR_INVOICES',
  SET_FILTERS: '@INVOICE/SET_FILTERS'
}
